import React from 'react'

import { highlightSearchMatch } from '../../../../utils/search'

type MatchedTextProps = {
  text: string
  search: string
}

export const SearchedText = ({ text, search }: MatchedTextProps) => {
  const parts = highlightSearchMatch(text, search)

  return (
    <>
      {parts.map((part, index) =>
        part.isBold ? <strong key={index}>{part.text}</strong> : part.text,
      )}
    </>
  )
}
